import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'portal',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'nodis-catalog',
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://sso.nodis.com.br/auth/',
  sslRequired: 'external',
  resource: 'portal',
  publicClient: true,
  verifyTokenAudience: true,
  useResourceRoleMappings: true,
  confidentialPort: 0,
});

export async function getValidToken() {
  try {
    await keycloak.updateToken(30);
    return keycloak.token;
  } catch (error) {
    await keycloak.login();
    return null;
  }
}

export default keycloak;
